import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import financeSettingsManagerReducer from '../reducers/financeSettingsManagerReducer';

const configureStore = (railsProps) => (
  createStore(financeSettingsManagerReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
